<template>
    <div :class="[{ 'lb-creation-card': isCreation }]" class="is-large">
        <div
            :class="{ 'has-background-white-ter': !isValidated && !isCreation }"
            class="lb-community-post"
        >
            <div class="lb-card-content">
                <div>
                    <div v-if="!isCreation" class="level is-mobile">
                        <div class="level-left is-shrinkable">
                            <div class="level-item is-shrinkable">
                                <span class="is-size-6 has-text-weight-bold">
                                    {{ content.created | timeFormatPost }}
                                </span>
                            </div>
                        </div>
                        <div v-if="content.owner" class="level-right">
                            <div class="level-item">
                                <p
                                    :data-tooltip="content.owner.name"
                                    class="image is-24x24 has-tooltip-bottom"
                                >
                                    <img
                                        :src="content.owner.avatar"
                                        loading="lazy"
                                        class="is-rounded lb-avatar"
                                        referrerpolicy="no-referrer"
                                    />
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="model.message">
                    <input-rich-text
                        v-if="isCreation || content.message"
                        v-model="content.message"
                        :editable="isCreation"
                        :placeholder="$t('Community.message_placeholder')"
                        :suggestions="participants"
                    />
                </div>

                <community-post-media
                    :show-controls="isCreation"
                    :image.sync="content.image"
                    :video.sync="content.video"
                    :url.sync="content.link"
                    :embed.sync="content.embed"
                    class="pt-4"
                />

                <div v-if="content.event" class="pt-3">
                    <section
                        :class="{
                            'has-background-very-light-pink-two':
                                !content.event.image,
                        }"
                        class="hero is-medium has-background"
                    >
                        <img
                            v-if="content.event.image"
                            :src="content.event.image.url"
                            alt
                            class="hero-background"
                        />
                        <div class="hero-body"></div>
                    </section>
                    <div class="lb-project-modal-content has-text-centered">
                        <p
                            class="
                                title
                                is-size-6
                                has-text-black
                                is-uppercase
                                mb-0
                                pt-4
                            "
                        >
                            <span class="icon">
                                <i class="far fa-lg fa-calendar-alt"></i>
                            </span>
                            <span class="category">
                                {{ $t('Constants.EVENT_CATEGORY_EVENT') }}
                            </span>
                        </p>
                        <p class="title is-size-5 has-text-pink-red mb-0">
                            {{ eventDate }}h
                        </p>
                        <p class="title is-size-5 has-text-black">
                            {{ content.event.title }}
                        </p>
                        <p class="is-size-6 has-text-black">
                            {{ content.event.description }}
                        </p>
                        <p class="is-size-6"></p>
                        <div v-if="content.event.url" class="field">
                            <div class="control">
                                <div class="buttons is-centered">
                                    <a
                                        :href="
                                            content.event.url.url ||
                                            content.event.url
                                        "
                                        class="
                                            button
                                            is-primary
                                            mt-2
                                            is-uppercase
                                        "
                                        target="_blank"
                                    >
                                        {{
                                            content.event.url.title ||
                                            content.event.url
                                        }}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="content.activity" class="pt-3">
                    <section
                        :class="{
                            'has-background-very-light-pink-two':
                                !content.activity.image,
                        }"
                        class="hero is-medium has-background"
                    >
                        <img
                            v-if="content.activity.image"
                            :src="content.activity.image.url"
                            alt
                            class="hero-background"
                        />
                        <div class="hero-body"></div>
                    </section>
                    <div class="lb-project-modal-content">
                        <p
                            class="
                                title
                                is-size-5
                                has-text-black has-text-centered
                                pt-5
                            "
                        >
                            {{ content.activity.title }}
                        </p>
                        <div
                            class="is-size-6 has-text-black"
                            v-html="content.activity.shortDescription"
                        ></div>
                        <p class="is-size-6"></p>
                        <p
                            class="
                                title
                                is-size-6
                                has-text-black
                                is-uppercase
                                mb-0
                                pt-4
                            "
                        >
                            <span class="category">
                                {{ content.activity.area }}
                            </span>
                        </p>
                    </div>
                </div>

                <community-post-toolbar
                    v-if="isCreation"
                    :show-controls="isCreation"
                    :saving="saving"
                    @click="openModal"
                    @saveObject="$emit('save', content)"
                />

                <div
                    v-if="!isCreation"
                    class="level is-mobile py-4 is-marginless"
                    @click.stop
                >
                    <div
                        :class="{ 'has-cursor-pointer': isLoggedIn }"
                        class="level-left"
                    >
                        <div
                            :class="{ 'has-text-primary': content.liked }"
                            class="level-item"
                            @click="toggleLike"
                        >
                            <p class="has-text-weight-bold">
                                {{ content.likes || 0 }}
                            </p>
                            <span class="icon is-medium">
                                <i
                                    class="mdi mdi-18px mdi-thumb-up"
                                    aria-hidden="true"
                                ></i>
                            </span>
                        </div>
                    </div>
                    <div class="level-right">
                        <div class="level-item">
                            <div
                                class="
                                    dropdown
                                    is-right is-hoverable is-pulled-right
                                "
                            >
                                <span
                                    class="
                                        icon
                                        is-small
                                        dropdown-trigger
                                        has-text-grey
                                    "
                                >
                                    <i
                                        class="mdi mdi-24px mdi-dots-vertical"
                                        aria-hidden="true"
                                    />
                                </span>
                                <div class="dropdown-menu" role="menu">
                                    <div class="dropdown-content">
                                        <!--a div class="dropdown-item">
                      <
                        v-t="'Object.share'" 
                        @click="showShareModal = true" />
                                        </div-->
                                        <a
                                            v-if="isOwner || isCommunityAdmin"
                                            v-t="'Options.delete'"
                                            class="dropdown-item"
                                            @click="deletePost"
                                        />
                                        <a
                                            v-if="isOwner"
                                            v-t="'Options.edit'"
                                            class="dropdown-item"
                                            @click="$emit('edit')"
                                        />
                                        <a
                                            v-if="
                                                !isValidated && isCommunityAdmin
                                            "
                                            v-t="'Options.validate'"
                                            class="dropdown-item"
                                            @click="$emit('validate')"
                                        ></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <object-card-comments
                    v-if="!isCreation && isMember && isValidated"
                    :creation-disabled="!isCommunityAdmin"
                    :edition-disabled="!isCommunityAdmin"
                    :comments="content.comments"
                    :object="content"
                    :model-related="'community'"
                    :render-all="showAllComments"
                    :has-editor="true"
                    :suggestions="profiles"
                    @loadOldComments="showAllComments = true"
                />
            </div>
        </div>
    </div>
</template>

<script>
import CommunityPostToolbar from '@/components/CommunityPostToolbar';
import CommunityPostMedia from '@/components/CommunityPostMedia';
import ObjectCardComments from '@/components/ObjectCardComments';
import InputRichText from '@/components/InputRichText';
import _ from 'underscore';
import { likePost } from '@/services/API';
import moment from 'moment';
export default {
    components: {
        CommunityPostToolbar,
        CommunityPostMedia,
        ObjectCardComments,
        InputRichText,
    },
    filters: {
        timeFormat(timestamp) {
            return moment(timestamp).format('DD/MM/YY HH:mm');
        },
        timeFormatPost(timestamp) {
            return moment(timestamp).format('DD/MM/YY');
        },
    },
    props: {
        content: {
            type: Object,
            default() {
                return {};
            },
        },
        model: {
            type: Object,
            default() {
                return {};
            },
        },
        isCreation: { type: Boolean, default: false },
        saving: { type: Boolean, default: false },
    },
    data() {
        return {
            startReadingTime: null,
            observer: null,
            isIntersecting: false,
            showToolbar: false,
            showAllComments: false,
            showShareModal: false,
            resizeObserver: new ResizeObserver((entries) => {
                for (let entry of entries) {
                    this.$emit('resize');
                }
            }),
        };
    },
    computed: {
        isLoggedIn() {
            return this.$store.getters.isLoggedIn;
        },
        isMember() {
            return this.$store.getters.community.accessLevel !== 'read';
        },
        isCommunityAdmin() {
            return this.$store.getters.community.accessLevel == 'administrator';
        },
        isOwner() {
            return this.content.owner.owner === this.$store.getters.user.owner;
        },
        participants() {
            return _.map(
                this.$store.getters.community.participants,
                (participant) => {
                    return participant.owner;
                }
            );
        },
        profiles() {
            return _.map(
                this.$store.getters.community.participants,
                (participant) => {
                    return participant.profile;
                }
            );
        },
        isValidated() {
            return this.content.status == 'PUBLISHED';
        },
        eventDate() {
            return moment(this.content.event.range.start).format(
                'DD/MM/YYYY h:mm'
            );
        },
    },
    watch: {
        isIntersecting(newValue, oldValue) {
            if (this.content._id == 'draft') {
                return;
            }
            if (this.isIntersecting) {
                this.startReadingTime = new Date();
                this.$ga.event({
                    eventCategory: 'Post',
                    eventAction: 'view',
                    eventLabel: this.content._id,
                });
            }
            if (newValue == false && oldValue == true) {
                this.$ga.event({
                    eventCategory: 'Post',
                    eventAction: 'reading_time',
                    eventLabel: this.content._id,
                    value: new Date() - this.startReadingTime,
                });
                this.startReadingTime = null;
            }
        },
    },
    created() {
        this.observer = new IntersectionObserver(this.onElementObserved, {
            root: this.$el,
            threshold: 1.0,
        });
    },
    beforeDestroy() {
        this.observer = null;
    },
    mounted() {
        this.observer.observe(this.$el);
    },

    methods: {
        onElementObserved(entries) {
            entries.forEach(({ target, isIntersecting }) => {
                this.isIntersecting = isIntersecting;
            });
        },
        openModal(e) {
            this.$emit('addElement', e.type);
        },
        deletePost() {
            if (confirm(this.$t('delete_post_confirmation_message'))) {
                this.$store
                    .dispatch('deletePost', {
                        post: this.content,
                        community: this.$store.getters.community._id,
                    })
                    .catch((e) => {
                        console.error('error creatiorn', e);
                        return;
                    });
            }
        },
        async toggleLike() {
            if (this.isLoggedIn) {
                let likeResult = await likePost(this.content._id);
                this.content.liked = likeResult.data.liked;
                this.content.likes = likeResult.data.likes;
            }
        },
    },
};
</script>

<style scoped lang="sass">
.toolbar
    position: absolute
    top: -20px
    right: 10px

.hero
    &.has-background
        position: relative
        overflow: hidden
    &-background
        position: absolute
        object-fit: cover
        object-position: center center
        width: 100%
        height: 100%
        &.is-transparent
            opacity: 0.3
</style>
<style scoped>
.hero-body {
    z-index: 1;
}
.lb-community-partner-image {
    bottom: 1rem;
    left: 1rem;
    max-width: 200px;
}
.hero.has-background .close {
    z-index: 2;
    position: absolute;
    text-shadow: 2px 3px 2px rgb(0 0 0 / 50%);
}
.category {
    display: inline-block;
    padding-top: 0.3rem;
    vertical-align: top;
}
/deep/.editor__content {
    padding-left: 0.75rem;
}
</style>
